define.alias("shared/components/shared/media-items/media-item-video", "media/components/shared/media-items/media-item-video");